//*******************************************************
import { Component, HostListener } from '@angular/core';
//*******************************************************
// Router
import { Router, ActivatedRoute }   from '@angular/router';

import { Observable, Subscription }       from 'rxjs';
//*******************************************************
// Firestore 
import { firestorecontrol }               from "../../appfirestore/app.firestore";
//**************************************************************
// Field Definitions
import { 
          inviteefield, 
          whoseguestinit
        }                           from '../../appfirestore/app.fields';
//*******************************************************
@Component(
            {
              selector: 'app-cominviteersvp',
              templateUrl: './cominviteersvp.component.html',
              styleUrls: ['./cominviteersvp.component.scss']
            }
          )

//*******************************************************
export class CominviteersvpComponent 
{
  //*******************************************************
  eventid: string = '';
  formheight: number = 0;

  // Firestore Paths
  pathinvitee: string       = "/eventinvitee/inviteelist"; 
  pathtableseatlist: string = "/eventtableseatlist/tableseatlist";

  // invitee not coming
  subscriptioninviteenotcoming: Subscription;
  subscriptioninviteenotcominglist: inviteefield[];

  // invitee undecided
  subscriptioninviteeundecided: Subscription;
  subscriptioninviteeundecidedlist: inviteefield[];

  // invitee confirm
  subscriptioninviteeconfirm: Subscription;
  subscriptioninviteeconfirmlist: inviteefield[];

   whoseguest: Array<whoseguestinit> = []; // Empty Array

   
  //*******************************************************
  constructor (
                private routernavigate: Router,
                private firestoredata: firestorecontrol, 
                private _Activatedroute:ActivatedRoute
              ) 
    { 

      this.onAdd = this.onAdd.bind(this);
      this.onDragStartInviteeName = this.onDragStartInviteeName.bind(this);

    }
  //*******************************************************
  ngOnInit(): void 
    {
        // EventId
        this.eventid     = String(this._Activatedroute.snapshot.paramMap.get("eventid"))
        // Form Height
        this.formheight  =  Number(this._Activatedroute.snapshot.paramMap.get("formheight"));
        //---------------------------------------------------------------------------------------------
        // Invitee not confirm to attend
        this.firestoredata.loadeventinviteenotcoming( this.eventid );

        this.subscriptioninviteenotcoming = this.firestoredata.geteventinviteenotcoming().subscribe
          ( items => 
            { 
              this.subscriptioninviteenotcominglist = items;
              //console.log( this.subscriptioninviteenotcominglist )
            }
          )
        //---------------------------------------------------------------------------------------------
        // Invitee undecided
        this.firestoredata.loadeventinviteeundecided( this.eventid );

        this.subscriptioninviteeundecided = this.firestoredata.geteventinviteeundecided().subscribe
          ( items => 
            { 
              this.subscriptioninviteeundecidedlist = items;
             // console.log( this.subscriptioninviteenotconfirmlist )
            }
          )
        //---------------------------------------------------------------------------------------------
        // Invitee confirm to attend
        this.firestoredata.loadeventinviteecoming( this.eventid );

        this.subscriptioninviteeconfirm = this.firestoredata.geteventinviteeConfirm().subscribe
          ( items => 
            { 
              this.subscriptioninviteeconfirmlist = items;
             // console.log( this.subscriptioninviteeconfirmlist )
            }
          )
        //---------------------------------------------------------------------------------------------
        this.firestoredata.buildwhoseguestdetails( this.eventid );
        this.whoseguest = this.firestoredata.geteventparticipantdetails();
        //---------------------------------------------------------------------------------------------
    }
  //*******************************************************
  ngOnDestroy() 
    {
      console.log('destroy1')
      this.subscriptioninviteenotcoming.unsubscribe(); 
      this.subscriptioninviteeundecided.unsubscribe();
      this.subscriptioninviteeconfirm.unsubscribe();
    }
  //*******************************************************
  // Adding Invitee Name to Invitation List
  onAdd(e) 
    {
  
      // console.log( e )
      //  console.log( e.fromData )
      //  console.log( e.toData )

      let inviteeid = e.itemData.id;
      let table     = e.itemData.table;
      let seatno    = e.itemData.seatno;

      console.log( inviteeid  + ' ' + table + ' ' + seatno  )
      //---------------------------------------------------------------------------------------------
      // List - Undecided 
      // Undecided -> Confirm
      if (  e.fromData == 'subscriptioninviteeundecidedlist' && e.toData == 'subscriptioninviteeconfirmlist' )
        {
          // Not Coming => Coming
          this.firestoredata.commitbatchupdate( 
                                                    this.pathinvitee, 
                                                    this.eventid,
                                                    inviteeid,
                                                    'coming', 
                                                    1
                                              );  
        }
      //---------------------------------------------------------------------------------------------
      // Undecided -> Not Coming
      if ( e.fromData == 'subscriptioninviteeundecidedlist' && e.toData == 'subscriptioninviteenotcominglist' ) 
        {
          // Not Coming => Coming
          this.firestoredata.commitbatchupdate( 
                                                    this.pathinvitee, 
                                                    this.eventid,
                                                    inviteeid,
                                                    'coming', 
                                                    -1
                                              );  
        }
      //---------------------------------------------------------------------------------------------
      // List - Confirmed
      // Confirm -> Undecided
      if ( e.fromData == 'subscriptioninviteeconfirmlist' && e.toData == 'subscriptioninviteeundecidedlist' )
        {

          // Coming => Undecided
          this.firestoredata.commitbatchupdate( 
                                                  this.pathinvitee, 
                                                  this.eventid,
                                                 inviteeid,
                                                  'coming', 
                                                  0
                                              );  

          if ( table != '0' )
            {
              console.log( 'Reset table list ')

              // Set Invitee-fld Table to blank
              this.firestoredata.commitbatchupdate( 
                                                      this.pathinvitee, 
                                                      this.eventid,
                                                      inviteeid,
                                                      'table', 
                                                      '0'
                                                  );  


              this.firestoredata.gettableinviteelist(  this.eventid, this.pathtableseatlist, table, seatno)
              
            }
        }
      //---------------------------------------------------------------------------------------------
      // Confirm -> Not Coming
      if ( e.fromData == 'subscriptioninviteeconfirmlist' && e.toData == 'subscriptioninviteenotcominglist' ) 
       {
          
          // Coming => Not Coming
    //      this.firestoredata.commitbatchupdate( 
    //                                              this.pathinvitee, 
    //                                              this.eventid,
    //                                              inviteeid,
    //                                              'coming', 
    //                                              -1
    //                                          );  

    //      if ( table != '0' )
    //        {
    //          console.log( 'Reset table list ')

    //         this.firestoredata.commitbatchupdate( 
    //                                                  this.pathinvitee, 
    //                                                  this.eventid,
    //                                                  inviteeid,
    //                                                  'table', 
    //                                                  '0'
    //                                              );  

     //         this.firestoredata.gettableinviteelist(  this.eventid, this.pathtableseatlist, table, seatno)
     //       }
       }
      //---------------------------------------------------------------------------------------------
      // List - Not Coming
      // Not Coming -> Undecided
      if ( e.fromData == 'subscriptioninviteenotcominglist' && e.toData == 'subscriptioninviteeundecidedlist' )
        {

          // Coming => Undecided
          this.firestoredata.commitbatchupdate( 
                                                  this.pathinvitee, 
                                                  this.eventid,
                                                  inviteeid,
                                                  'coming', 
                                                  0
                                              );  
        }
      //---------------------------------------------------------------------------------------------
      // Not Coming -> Coming
      if ( e.fromData == 'subscriptioninviteenotcominglist' && e.toData == 'subscriptioninviteeconfirmlist' )
          {

          

            // Coming => Not Coming
     //       this.firestoredata.commitbatchupdate( 
     //                                               this.pathinvitee, 
     //                                               this.eventid,
      //                                              inviteeid,
      //                                              'coming', 
      //                                              1
      //                                          );  
         }
      //---------------------------------------------------------------------------------------------
    
    }
  //*******************************************************
  // Dragging Invitee Details frpm DataGrid
  onDragStartInviteeName(e) 
      {
       // console.log(e )
        // Invitee Id
       // this.dragitem_inviteeid = e.itemData.id;
      //  this.dragitem           = e.itemData.firstname + ' ' + e.itemData.lastname + ' - [' +  e.itemData.id + ']' ;

      //  console.log (  this.dragitem_inviteeid  + ' ' + this.dragitem )
      }
  //*******************************************************

}
//*******************************************************